
















































import { defineComponent, ref } from "@vue/composition-api";
import { useGetters } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import ProjectCard from "@c/molecules/project/ProjectCard.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";
import SkeletonIndex from "@c/molecules/project/SkeletonIndex.vue";
import PlaceModel from "@/ts/models/placeClass";

export default defineComponent({
  name: "Projects",

  components: {
    ProjectCard,
    CreateButton,
    SkeletonIndex
  },

  props: {
    place: Object as () => PlaceModel
  },

  setup(props, { root }) {

    var hash = ref(null);
    const place_id = parseInt(root.$route.params.id);

    var { entity: projects, loading: loading_projects } = useFetcher(
      "project/GET_PROJECTS_BY_PLACE",
      {action_param:place_id}
    );

    return {
      projects,
      loading_projects
    };
  }
});
